import {
  Box,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import React from 'react'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { gameState, modalState, userState } from './store'
import { numberWithCommas } from './utils'

export default function History() {
  const game = useRecoilValue(gameState)
  const user = useRecoilValue(userState)

  const setModal = useSetRecoilState(modalState)

  return (
    <Box>
      <Table variant="striped" size="sm">
        <Thead>
          <Tr>
            <Th>result</Th>
            <Th>@</Th>
            <Th>bet</Th>
            <Th>profit</Th>
            <Th>hash</Th>
          </Tr>
        </Thead>
        <Tbody>
          {game.history.map(game => {
            const bet = game.bets.find(bet => bet.username === user.username)

            return (
              <Tr key={game.id}>
                <Td color={game.result > 200 ? 'green.500' : 'red.500'}>
                  <Text
                    as="span"
                    cursor="pointer"
                    onClick={() => setModal(`game ${game.id}`)}
                  >
                    {(game.result / 100).toFixed(2)}x
                  </Text>
                </Td>
                <Td>{bet && bet.multiplier ? bet.multiplier / 100 : '-'}</Td>
                <Td>{bet ? numberWithCommas(bet.amount) : '-'}</Td>
                <Td>
                  {!bet && '-'}
                  {bet &&
                    bet.multiplier &&
                    numberWithCommas(
                      Math.floor(
                        bet.amount * (bet.multiplier / 100) - bet.amount
                      )
                    )}
                  {bet && !bet.multiplier && `-${numberWithCommas(bet.amount)}`}
                </Td>
                <Td whiteSpace="nowrap" overflow="hidden" maxW="50px">
                  <Input h="5" size="sm" value={game.hash} isReadOnly={true} />
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </Box>

    // <UnorderedList styleType="none">

    // </UnorderedList>
  )
}
